import React from 'react';
import { Button } from 'reactstrap';
import LucideIcon from '../lucide-icon';

const buttonIconStyle = {
  alignItems: 'center',
  display: 'inline-flex',
  height: 24,
  justifyContent: 'center',
  lineHeight: 0,
  verticalAlign: 'middle',
  width: 16,
};

function renderIcon(icon, className, iconSize, iconProps = {}) {
  if (!icon) return null;

  if (typeof icon === 'string') {
    return (
      <span className={className} style={buttonIconStyle}>
        <LucideIcon icon={icon} size={iconProps.size || iconSize} {...iconProps} />
      </span>
    );
  }

  if (React.isValidElement(icon)) {
    return (
      <span className={className} style={buttonIconStyle}>
        {React.cloneElement(icon, {
          size: icon.props.size || iconSize,
          ...iconProps,
        })}
      </span>
    );
  }

  const LucideIconComponent = icon;

  return (
    <span className={className} style={buttonIconStyle}>
      <LucideIconComponent size={iconProps.size || iconSize} {...iconProps} />
    </span>
  );
}

function ButtonComponent({
  toolbar,
  icon,
  leftIcon,
  rightIcon,
  color = 'primary',
  iconSize,
  leftIconProps,
  rightIconProps,
  children,
  ...other
}) {
  const normalizedIconSize = iconSize || (toolbar ? 16 : 13);

  if (toolbar) {
    return (
      <Button color={color} {...other}>
        <div className="d-flex align-items-center justify-content-center">
          {renderIcon(icon, '', normalizedIconSize)}
          {children}
        </div>
      </Button>
    );
  }

  return (
    <Button color={color} {...other}>
      <div className="d-flex align-items-center justify-content-center">
        {renderIcon(leftIcon, 'mr-2', normalizedIconSize, leftIconProps)}
        {children}
        {renderIcon(rightIcon, 'mr-1', normalizedIconSize, rightIconProps)}
      </div>
    </Button>
  );
}

export default ButtonComponent;
